var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.257,
    cy: 18.257,
    r: 18.257,
    fill: "#FF0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0415 15.5647C16.6895 15.3543 16.2383 15.6086 16.2383 16.0209V20.9792C16.2383 21.3936 16.6902 21.6443 17.0415 21.4361L21.1987 18.9605C21.5444 18.7543 21.5437 18.2543 21.1994 18.0474L17.0415 15.5647ZM17.3008 20.0449V16.9566L19.8897 18.5029L17.3008 20.0449Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0987 12.3173C20.8028 11.8278 16.1986 11.8278 12.9013 12.3173C11.5824 12.5128 10.5433 13.5484 10.3166 14.8928C9.89446 17.3882 9.89446 19.6131 10.3166 22.1079C10.5433 23.453 11.5824 24.4879 12.9013 24.6834C14.5532 24.9285 16.5308 25.051 18.5078 25.051C20.4812 25.051 22.4539 24.9292 24.0994 24.6841C25.4169 24.4886 26.4553 23.4537 26.6834 22.1086C27.1055 19.6131 27.1055 17.3875 26.6834 14.8921C26.4567 13.5484 25.4176 12.5128 24.0987 12.3173ZM25.6357 21.9315C25.4849 22.8212 24.8049 23.5054 23.9428 23.6329C20.7426 24.1082 16.2659 24.1082 13.0572 23.6322C12.1944 23.504 11.5137 22.8205 11.3635 21.9308C10.957 19.5267 10.957 17.4747 11.3635 15.0692C11.5144 14.1795 12.1944 13.4967 13.0579 13.3677C14.6601 13.1305 16.5804 13.0115 18.4993 13.0115C20.4196 13.0115 22.3399 13.1305 23.9421 13.3677C24.8049 13.496 25.4856 14.1795 25.6357 15.0692C26.0423 17.4747 26.0423 19.5267 25.6357 21.9315Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYt);
export default __webpack_public_path__ + "static/media/yt.680ae3942e276cd077fd784d698e346f.svg";
export { ForwardRef as ReactComponent };